import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminGuard } from './guards/admin.guard';
import { UserGuard } from './guards/user.guard';
import { AdminAgencyGuard } from './guards/admin-agency.guard';
import { RoleGuard } from './guards/role.guard';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [AdminGuard, UserGuard, AdminAgencyGuard, RoleGuard],
})
export class CoreModule {}
